import { Alert } from "@mui/material";
export default function LoginError({error, errorMessage}) {
  return (
    error && <Alert severity="error" sx={{marginTop : 2}}>{errorMessage}</Alert>
  );
}
